import endpoints from 'constants/endpoints';
import { authorizedPOST } from 'helpers/requester_next/requester';

export const inviteMember = (email, roleID) => authorizedPOST(endpoints.inviteMember, { email, role_id: roleID });
